<template>
    <div class="mid-pane">
        <!--    Mobile left Pane-->
        <mobile-left-bar></mobile-left-bar>
        <!--    Mobile left Pane END-->

        <div class="hold">
            <!--        NavBar-->
            <div class="nav-bar">
                <div class="nav-hold">
                    <div class="back-icon" @click="backButton()">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.1 31.1">
                        <path d="M30.2 16.4H0.9C0.4 16.4 0 16 0 15.5c0-0.5 0.4-0.9 0.9-0.9h29.3c0.5 0 0.9 0.4 0.9 0.9C31.1 16 30.7 16.4 30.2 16.4z" class="a"></path>
                        <path d="M16 31.1c-0.2 0-0.4-0.1-0.6-0.2L0.3 16.2C0.1 16 0 15.8 0 15.5c0-0.2 0.1-0.5 0.3-0.6L15.4 0.3c0.4-0.3 0.9-0.3 1.3 0 0.3 0.4 0.3 0.9 0 1.3L2.2 15.5l14.5 14c0.4 0.3 0.4 0.9 0 1.3C16.5 31 16.2 31.1 16 31.1z"></path>
                    </svg>
                </span>
                    </div>

                    <div class="nav-text alt">
                        <p class="main">Pay Bills</p>
                    </div>
                </div>
            </div>
            <!--        Intro Text-->
            <div class="option-component">
                <div class="intro-text">
                    <div class="row">
                        <div class="col-sm-6">
                            <p class="big">
                                Bills Payment Made Easy:
                                You have three types of bills
                            </p>
                        </div>
                        <div class="col-sm-6">
                            <p class="small">
                                Airtime-top on any network, mobile data subscibtion plans,
                                and bills payments for a wide range of merchants
                            </p>
                        </div>
                    </div>
                </div>

                <div class="options">
                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div @click="goToAirtime()" class="opt">
                                <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path d="M458.7 181.3c-14.7 0-37 5.1-53.3 20.4V32c0-17.7-14.3-32-32-32H138.7c-17.7 0-32 14.3-32 32v128h-32c-17.7 0-32 14.3-32 32v21.3c0 8.2 3.1 15.7 8.2 21.3 -5.1 5.7-8.2 13.1-8.2 21.3v21.3c0 8.2 3.1 15.7 8.2 21.3 -5.1 5.7-8.2 13.1-8.2 21.3v21.3c0 8.2 3.1 15.7 8.2 21.3 -5.1 5.7-8.2 13.1-8.2 21.3v21.3c0 17.7 14.3 32 32 32h32V480c0 17.7 14.3 32 32 32h234.7c17.7 0 32-14.3 32-32V248.6c1.7-22.8 19.3-41.9 42.7-44.8v297.5h21.3V192C469.3 186.1 464.6 181.3 458.7 181.3zM138.7 21.3h234.7C379.2 21.3 384 26.1 384 32v32H128V32C128 26.1 132.8 21.3 138.7 21.3zM64 341.3V320c0-5.9 4.8-10.7 10.7-10.7h32V352h-32C68.8 352 64 347.2 64 341.3zM64 277.3V256c0-5.9 4.8-10.7 10.7-10.7h32V288h-32C68.8 288 64 283.2 64 277.3zM64 192c0-5.9 4.8-10.7 10.7-10.7h32V224h-32C68.8 224 64 219.2 64 213.3V192zM74.7 416C68.8 416 64 411.2 64 405.3V384c0-5.9 4.8-10.7 10.7-10.7h32V416H74.7zM373.3 490.7H138.7c-5.9 0-10.7-4.8-10.7-10.7v-32h256v32C384 485.9 379.2 490.7 373.3 490.7zM384 426.7H128v-64 -64 -64 -64V85.3h256V426.7z"></path>
                                        <path d="M256 149.3c-58.9 0-106.7 47.8-106.7 106.7S197.1 362.7 256 362.7c58.9-0.1 106.6-47.8 106.7-106.7C362.7 197.1 314.9 149.3 256 149.3zM256 341.3c-47.1 0-85.3-38.2-85.3-85.3s38.2-85.3 85.3-85.3c47.1 0.1 85.3 38.2 85.3 85.3C341.3 303.1 303.1 341.3 256 341.3z"></path>
                                    </svg>
                                </span>
                                </div>
                                <p class="hed">Buy Airtime</p>
                                <p class="sub">MTN, glo, Airtel & 9mobile airtime recharge</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div @click="goToMobileData()" class="opt">
                                <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                        <path d="M453.1 326.4c-1.2-2.8-3.9-4.6-6.9-4.6h-29v-91.1c0-4.1-3.4-7.5-7.5-7.5H376.7v-30.3h2.1c8.7 0 15.8-6.7 15.8-15v-16c0-8.3-7.1-15-15.8-15h-2.1V38C376.7 17.1 359.6 0 338.6 0H114.3C93.3 0 76.2 17.1 76.2 38v42.6h-2.1c-8.7 0-15.8 6.7-15.8 15v16c0 8.3 7.1 15 15.8 15h2.1v7.9h-2.1c-8.7 0-15.8 6.7-15.8 15v16c0 8.3 7.1 15 15.8 15h2.1V373.7c0 4.1 3.4 7.5 7.5 7.5 4.1 0 7.5-3.4 7.5-7.5V106.1h270.5v117.1h-31.5c-4.1 0-7.5 3.4-7.5 7.5v91.1h-29c-3 0-5.8 1.8-6.9 4.6 -1.2 2.8-0.5 6 1.6 8.2l73.3 73.3v43.3H91.2V403.6c0-4.1-3.4-7.5-7.5-7.5 -4.1 0-7.5 3.4-7.5 7.5v70.4c0 21 17.1 38 38 38h224.4c21 0 38-17.1 38-38v-64.6l74.8-74.8C453.6 332.4 454.2 329.2 453.1 326.4zM76.2 165.7h-2.1c-0.4 0-0.7-0.1-0.8-0.2v-15.6c0.1-0.1 0.4-0.2 0.8-0.2h2.1V165.7zM76.2 111.7h-2.1c-0.4 0-0.7-0.1-0.8-0.2v-15.6c0.1-0.1 0.4-0.2 0.8-0.2h2.1V111.7zM376.7 161.8h2.1c0.4 0 0.7 0.1 0.8 0.2v15.6c-0.1 0.1-0.4 0.2-0.8 0.2h-2.1V161.8zM91.2 91.1V69.3h189.1c4.1 0 7.5-3.4 7.5-7.5 0-4.1-3.4-7.5-7.5-7.5H91.2V38c0-12.7 10.3-23 23-23h224.4c12.7 0 23 10.3 23 23v16.3h-52.3c-4.1 0-7.5 3.4-7.5 7.5 0 4.1 3.4 7.5 7.5 7.5h52.3V91.1H91.2zM361.7 474c0 12.7-10.3 23-23 23H114.3c-12.7 0-23-10.3-23-23v-7.8h270.5V474zM369.9 394.9l-58.1-58.1h18.4c4.1 0 7.5-3.4 7.5-7.5v-91.1h64.4v91.1c0 4.1 3.4 7.5 7.5 7.5h18.4L369.9 394.9z"></path>
                                        <path d="M345.3 200.8l-76.2-76.2c-2.9-2.9-7.7-2.9-10.6 0l-76.2 76.2c-2.1 2.1-2.8 5.4-1.6 8.2 1.2 2.8 3.9 4.6 6.9 4.6h29v30c0 4.1 3.4 7.5 7.5 7.5 4.1 0 7.5-3.4 7.5-7.5v-37.5c0-4.1-3.4-7.5-7.5-7.5H205.6l58.1-58.1 58.1 58.1h-18.4c-4.1 0-7.5 3.4-7.5 7.5v91.1h-64.4v-27.9c0-4.1-3.4-7.5-7.5-7.5 -4.1 0-7.5 3.4-7.5 7.5v35.4c0 4.1 3.4 7.5 7.5 7.5h79.4c4.1 0 7.5-3.4 7.5-7.5v-91.1h29c3 0 5.8-1.8 6.9-4.6C348.1 206.2 347.4 203 345.3 200.8z"></path>
                                    </svg>
                                </span>
                                </div>
                                <p class="hed">Buy Mobile Data</p>
                                <p class="sub">MTN, glo, Airtel & 9mobile data bundles</p>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                            <div @click="goToOtherBills()" class="opt">
                                <div class="ico">
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 478.9 478.9">
                                        <path d="M406.9 160c0 0 0 0 0 0h-400c-3.8 0-6.9 3.1-6.9 6.8 0 0 0 0 0 0v192c0 3.8 3.1 6.9 6.8 6.9 0 0 0 0 0 0h272c3.8 0 6.9-3.1 6.9-6.9 0-3.8-3.1-6.9-6.9-6.9H13.7V173.7H400v17.1c0 3.8 3.1 6.9 6.8 6.9 0 0 0 0 0 0 3.8 0 6.9-3.1 6.9-6.8 0 0 0 0 0 0v-24C413.7 163.1 410.7 160 406.9 160z"></path>
                                        <path d="M360.4 128.2l-320-72c-1.8-0.4-3.6-0.1-5.2 0.9 -1.5 1-2.6 2.5-3 4.3l-16 72c-0.8 3.7 1.5 7.4 5.2 8.2 3.7 0.8 7.4-1.5 8.2-5.2l14.5-65.3 313.3 70.5c0.5 0.1 1 0.2 1.5 0.2 3.8 0 6.9-3.1 6.8-6.9C365.7 131.7 363.5 128.9 360.4 128.2z"></path>
                                        <path d="M321.5 88.5l-192-80c-3.3-1.4-7.2 0-8.8 3.3l-16 32c-1.8 3.3-0.6 7.5 2.8 9.3 3.3 1.8 7.5 0.6 9.3-2.8 0.1-0.1 0.1-0.3 0.2-0.4v0l13.1-26.3 186.1 77.5c3.5 1.5 7.5-0.2 9-3.7C326.7 94 325 90 321.5 88.5z"></path>
                                        <path d="M326.4 192h-63.5c-3.8 0-6.9 3.1-6.9 6.9 0 3.8 3.1 6.9 6.9 6.9h63.5c3.8 0 6.9-3.1 6.9-6.9S330.1 192 326.4 192z"></path>
                                        <path d="M198.9 192.5c-38.9 0-70.4 31.5-70.4 70.4 0 38.9 31.5 70.4 70.4 70.4 38.9 0 70.4-31.5 70.4-70.4S237.7 192.5 198.9 192.5zM198.9 320.5c-31.8 0-57.6-25.8-57.6-57.6 0-31.8 25.8-57.6 57.6-57.6 31.8 0 57.6 25.8 57.6 57.6C256.5 294.7 230.7 320.5 198.9 320.5z"></path>
                                        <path d="M390.9 214.9c-42.4 0-88 10-88 32v192c0 22 45.6 32 88 32 42.4 0 88-10 88-32v-192C478.9 224.9 433.3 214.9 390.9 214.9zM462.9 438.8c-1.2 4.4-25.2 16.1-72 16.1s-70.8-11.7-72-16v-12.6c17 8.6 45.1 12.6 72 12.6 26.9 0 55-4 72-12.6V438.8zM462.9 406.8c-1.2 4.4-25.2 16.1-72 16.1s-70.8-11.7-72-16v-12.6c17 8.6 45.1 12.6 72 12.6 26.9 0 55-4 72-12.6V406.8zM462.9 374.8c-1.2 4.4-25.2 16.1-72 16.1s-70.8-11.7-72-16v-12.6c17 8.6 45.1 12.6 72 12.6 26.9 0 55-4 72-12.6V374.8zM462.9 342.8c-1.2 4.4-25.2 16.1-72 16.1s-70.8-11.7-72-16v-12.6c17 8.6 45.1 12.6 72 12.6 26.9 0 55-4 72-12.6V342.8zM462.9 310.8c-1.2 4.4-25.2 16.1-72 16.1s-70.8-11.7-72-16v-12.6c17 8.5 45.1 12.6 72 12.6 26.9 0 55-4 72-12.6V310.8zM462.9 278.8c-1.2 4.4-25.2 16.1-72 16.1s-70.8-11.7-72-16v-12.6c17 8.5 45.1 12.6 72 12.6 26.9 0 55-4 72-12.6V278.8zM390.9 262.9c-46.7 0-70.7-11.6-72-15.9v0c1.3-4.5 25.3-16.1 72-16.1 46.4 0 70.4 11.5 72 16C461.3 251.4 437.3 262.9 390.9 262.9z"></path>
                                        <path d="M134.9 320H74.4l-28.7-31.4v-52l31.7-30.9h57.5c3.8 0 6.9-3.1 6.9-6.9 0-3.8-3.1-6.9-6.9-6.9H74.6c-1.8 0-3.5 0.7-4.8 1.9l-35.7 34.9c-1.3 1.6-2.1 3.5-2.1 5.6v56.9c0 1.7 0.6 3.4 1.8 4.6l32.5 35.6c1.3 1.4 3.1 2.2 5.1 2.2h63.5c3.8 0 6.9-3.1 6.9-6.9C141.7 323.1 138.6 320 134.9 320z"></path>
                                    </svg>
                                </span>
                                </div>
                                <p class="hed">Pay Other Bills</p>
                                <p class="sub">Pay tv cable bills, flight tickets etc.</p>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <footer-mobile></footer-mobile>
        </div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import MobileLeftBar from '../sidebar/MobileLeftBar'
    import FooterMobile from "../utility/FooterMobile";

    export default {
        name: "payBills",
        components: {
            FooterMobile,
            mobileLeftBar: MobileLeftBar,
        },
        props: { },
        data () {
            return { }
        },
        computed: {
            ...mapGetters([
                'getSideBarPage',
                'getInsideCurrentPage',
                'getUsername',
                'getDataOnLogin',
                'getCurrentAirtimePhoneNo',
            ])
        },
        created () {},
        methods: {
            ...mapActions([
                'updateAppLoading',
                'updateSideBarPage',
                'updateInsideCurrentPage',
                'updateMobileDataBiller',
                'updateCurrentAirtimePhoneNo',
            ]),

            backButton(){
                this.updateInsideCurrentPage('dashboard')
                this.updateSideBarPage('dashboard')
            },
            goToAirtime(){
                // update current airtime phone number
                this.updateCurrentAirtimePhoneNo([this.getDataOnLogin.countrycode, '0'+this.getDataOnLogin.mobilenumber])

                //Update the current sub component in the store
                this.updateInsideCurrentPage('airtime')
            },
            goToMobileData(){
                //start app loading
                this.updateAppLoading(true);

                let biller = {
                    mtn: {
                        tag: 'mtn',
                        billercode: "BIL108",
                        name: "MTN DATA BUNDLE",
                        products: []
                    },
                    glo: {
                        tag: 'glo',
                        billercode: "BIL109",
                        name: "GLO DATA BUNDLE",
                        products: []
                    },
                    airtel: {
                        tag: 'airtel',
                        billercode: "BIL110",
                        name: "AIRTEL DATA BUNDLE",
                        products: []
                    },
                    nineMobile: {
                        tag: '9mobile',
                        billercode: "BIL111",
                        name: "9MOBILE DATA BUNDLE",
                        products: []
                    }
                };

                axios
                    .post('/mobiledataproduct', {
                        username: this.getUsername,
                    }, {
                        'Authorization': this.getDataOnLogin.authorization,
                        'Content-Type': 'application/json',
                        'Access-Control-Allow-Origin': '*'
                    })
                    .then(response => {
                        let responseData = response.data;
                        // // console.log(responseData);

                        if (responseData.responsecode === '00') {
                            biller.mtn.products = responseData.BIL108;
                            biller.glo.products = responseData.BIL109;
                            biller.airtel.products = responseData.BIL110;
                            biller.nineMobile.products = responseData.BIL111;

                            //stop app loading
                            this.updateAppLoading(false);

                            // // console.log('Bank From Account Response ==>>', responseData)

                            this.updateMobileDataBiller (biller);

                            //Update the current sub component in the store
                            this.updateInsideCurrentPage('mobileData')
                        }
                    })
            },
            goToOtherBills(){
                //Update the current sub component in the store
                this.updateInsideCurrentPage('otherBills')
            },
        },
        mounted(){
            this.$nextTick(()=>{});
        },
    }
</script>

<style scoped>

</style>